<div class="product">
    <div>
        <div class="info" (click)="showComposition()"
            *ngIf="menu.compositions.elements.length>0 || menu.compositions.families.length>0">
            <img src="assets/images/arrows/info.png" alt="info">
        </div>
        <div class="main-img" [ngClass]="{loading:!loadAvatar}">
            <img [src]="menu.avatar|absolutePath:'menus'" [hidden]="!loadAvatar" (load)="loadAvatar=true"
                [alt]="'Livraison '+menu.category+' '+menu.title" [title]="'Livraison '+menu.category+' '+menu.title" />
        </div>
        <div class="compositions back" *ngIf="menu.showcomp">
            <div class="scr">
                <ul>
                    <ng-container *ngIf="menu.compositions.elements.length>0">
                        <li *ngFor="let comp of menu.compositions.elements[0]; let i=index;">
                            <b>{{comp.quantity}}</b> {{comp.name}} <ng-container *ngIf="comp.level">
                                ({{comp.size}})</ng-container>
                        </li>
                    </ng-container>
                    <ng-container *ngFor="let comp of menu.compositions.elements; let i=index;">
                        <ng-container *ngIf="i>0 && comp.length >0">
                            <li>
                                <ng-container *ngFor="let el of comp;let j=index">
                                    <b>{{el.quantity}}</b> {{el.name}} <ng-container *ngIf="el.level">
                                        ({{el.size}})
                                    </ng-container> <b *ngIf="j!=comp.length-1">OU</b>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="menu.compositions.families.length>0">
                        <li *ngFor="let comp of menu.compositions.families[0]; let j=index;">
                            <b>{{comp.quantity}}</b> {{comp.label}} <ng-container *ngIf="comp.level">
                                ({{comp.size}})
                            </ng-container>
                        </li>
                    </ng-container>
                    <ng-container *ngFor="let comp of menu.compositions.families; let i=index;">
                        <ng-container *ngIf="i>0 && comp.length >0">
                            <li>
                                <ng-container *ngFor="let el of comp;let j=index">
                                    <b>{{el.quantity}}</b> {{el.label}} <ng-container *ngIf="el.level">
                                        ({{el.size}})
                                    </ng-container> <b *ngIf="j!=comp.length-1">OU</b>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
    <div class="product-body">
        <h2>{{menu.title}}</h2>
        <div class="price">
            <ng-container *ngIf="!menu.offer">
                {{menu.price}} €
            </ng-container>
        </div>
        <p class="alert alert-danger mb-0 text-center radius-0"
            *ngIf="menu.cannotBeOrdered && menu.cannotBeOrderedText">
            {{menu.cannotBeOrderedText}}
        </p>
    </div>
    <div class="product-footer" *ngIf="!menu.cannotBeOrdered">
        <ng-container *ngIf="!siteClose;else temp1">
            <ng-container *ngIf="menu.dispoday;else temp2">
                <ng-container *ngIf="menu.dispo;else temp3">
                    <button *ngIf="menu.validPeriod==1;else temp4" class="add menu btn" aria-hidden="true"
                        (click)="addToBasket()">
                        Ajouter au panier
                        <img src="assets/imgs/addBasket.png" alt="" srcset="">
                    </button>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>


<ng-template #temp1>
    <button class="btn indisponible">
        Restaurant fermé
    </button>
</ng-template>
<ng-template #temp2>
    <button class="btn indisponible">INDISPONIBLE AUJOURD'HUI</button>
</ng-template>
<ng-template #temp3>
    <button class="btn indisponible text-uppercase">{{menu.ordertype}} NON DISPONIBLE</button>
</ng-template>
<ng-template #temp4>
    <button class="btn indisponible" *ngIf="menu.menuTime==1">Midi uniquement</button>
    <button class="btn indisponible" *ngIf="menu.menuTime==3">Soir uniquement</button>
</ng-template>